import { render } from "./comment.vue?vue&type=template&id=00a369d8"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"

import "./comment.vue?vue&type=style&index=0&id=00a369d8&lang=scss"
script.render = render

export default script